import { observer } from "mobx-react";
import React, { Component } from "react";
import projectStore from "../../stores/projectStore";
import { Link } from "react-router-dom";
import { LuPencil, LuTrash } from "react-icons/lu";
import { PiWarningCircleFill } from "react-icons/pi";
import Button from "../../components/Button";
import { AddNewTalentColoredIcon } from "../../assets/icons";

const Years = observer(
  class Years extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showDeleteModal: false,
        deleteYear: null,
        showEditModal: false,
        editYear: null,
      };
    }

    componentDidMount() {
      projectStore.getYears();
    }

    toggleDeleteModal = (deleteYear = null) => {
      this.setState({
        showDeleteModal: !this.state.showDeleteModal,
        deleteYear: deleteYear,
      });
    };

    handleDelete = () => {
      const { deleteYear } = this.state;
      if (deleteYear) {
        projectStore.deleteYear(deleteYear);
        this.setState({ showDeleteModal: false });
      }
    };

    toggleEditModal = (editYear = null) => {
      this.setState({
        showEditModal: !this.state.showEditModal,
        editYear: editYear,
      });
    };

    handleSave = () => {
      const { editYear } = this.state;
      if (editYear) {
        this.setState({ showEditModal: false });
      }
    };

    render() {
      const { showEditModal, showDeleteModal, editYear } = this.state;

      return (
        <div className="flex flex-col p-8 bg-white flex-1 h-screen">
          <div className="flex flex-row justify-between mb-8 items-center">
            <div className="font-bold">Projects</div>

            {/* Add Button */}
            <div className="flex justify-end mx-6 gap-3 lg:gap-6">
              {/* Desktop Button */}
              <Button
                className="hidden md:flex rounded-md"
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true);
                }}
                icon={AddNewTalentColoredIcon}
                title={"Add New"}
              />
              {/* Mobile Button */}
              <Button
                onClick={() => {
                  projectStore.setCreateNewProjectModalVisible(true);
                }}
                className="flex md:hidden rounded-md"
                icon={AddNewTalentColoredIcon}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="flex justify-center lg:justify-start flex-row flex-wrap gap-6 lg:gap-12">
            {projectStore.years &&
              projectStore.years.map((year, index) => {
                return (
                  <div
                    key={year + index}
                    className="flex relative overflow-hidden border-[3px]  border-[#F89A1F] rounded-xl text-[#130D0D] group hover:bg-[#f89a1f] hover:border-[#F89A1F] transition-all duration-100	"
                  >
                    <Link
                      to={`/projects/${year}`}
                      className="flex relative overflow-hidden px-10 py-6 lg:px-16 lg:py-8"
                    >
                      <span
                        key={index}
                        className="font-medium text-xl text-[#130D0D] group-hover:text-white"
                      >
                        {year}
                      </span>
                    </Link>

                    <button
                      onClick={() => {
                        this.toggleDeleteModal(year);
                      }}
                      className="cursor-pointer absolute top-0 right-0 lg:top-0 lg:right-0 p-2 bg-[#f89a1f] rounded-bl-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuTrash />
                    </button>
                    <button
                      onClick={() => this.toggleEditModal(year)}
                      className="cursor-pointer absolute bottom-0 lg:bottom-auto lg:top-0 right-0 lg:right-9 p-2 bg-[#f89a1f] rounded-tl-xl lg:rounded-tl-none lg:rounded-b-xl text-white group-hover:text-[#f89a1f] group-hover:bg-white"
                    >
                      <LuPencil />
                    </button>
                  </div>
                );
              })}
          </div>

          {/* Delete Modal */}
          {showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this year?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => {
                      this.toggleDeleteModal(editYear);
                    }}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={this.handleDelete}
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Edit Modal */}
          {showEditModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <h3 className="text-lg font-semibold mb-4">Update Year</h3>

                <div className="mb-4">
                  <input
                    type="number"
                    value={editYear}
                    onChange={(e) => {
                      this.setState({ editYear: e.target.value });
                    }}
                    className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                  />
                </div>

                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleEditModal}
                    className="border border-gray-300 bg-white px-3 py-2 rounded-xl"
                  >
                    Cancel
                  </button>
                  <Button onClick={this.handleSave} title="Update"></Button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

export default Years;
